import type { CrudSort } from "@refinedev/core";

type SortParam = { sortBy?: string | string[] };

const mapOrder = (order?: string) =>
  order?.toLowerCase() === "ascend" || order?.toLowerCase() === "asc"
    ? "ASC"
    : "DESC";

export const generateSort = (sorters?: CrudSort[]): SortParam => {
  if (!sorters?.length) return {};

  const parts = sorters
    .filter((s) => s?.field && s?.order)
    .map(({ field, order }) => `${String(field)}:${mapOrder(order)}`);

  if (parts.length === 0) return {};

  return {
    sortBy: parts.length === 1 ? parts[0] : parts,
  };
};
